import * as React from 'react';

type PersonProps = {
  size?: number;
  color?: string;
};

export function Person({
  size = 14,
  color = '#191F2E',
}: PersonProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 7C8.86396 7 10.375 5.48896 10.375 3.625C10.375 1.76104 8.86396 0.25 7 0.25C5.13604 0.25 3.625 1.76104 3.625 3.625C3.625 5.48896 5.13604 7 7 7ZM9.25 3.625C9.25 4.86764 8.24264 5.875 7 5.875C5.75736 5.875 4.75 4.86764 4.75 3.625C4.75 2.38236 5.75736 1.375 7 1.375C8.24264 1.375 9.25 2.38236 9.25 3.625Z"
        fill={color}
      />
      <path
        d="M13.75 12.625C13.75 13.75 12.625 13.75 12.625 13.75H1.375C1.375 13.75 0.25 13.75 0.25 12.625C0.25 11.5 1.375 8.125 7 8.125C12.625 8.125 13.75 11.5 13.75 12.625ZM12.625 12.6211C12.6234 12.3434 12.452 11.5118 11.6889 10.7486C10.9551 10.0148 9.57524 9.25 6.99999 9.25C4.42474 9.25 3.0449 10.0148 2.31111 10.7486C1.54797 11.5118 1.3766 12.3434 1.375 12.6211H12.625Z"
        fill={color}
      />
    </svg>
  );
}
